"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SvgIcon = (0, _createSvgIcon["default"])([/*#__PURE__*/React.createElement("rect", {
  width: "16",
  height: "16",
  rx: "4",
  key: "0"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1432_6549",
  style: {
    "maskType": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "2",
  y: "3",
  width: "12",
  height: "10",
  key: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.9102 3.897a.9265.9265 0 0 1 .1304 1.3037l-5.5588 6.7941a.9262.9262 0 0 1-1.3722.0684L3.0214 8.975a.9265.9265 0 0 1 1.3102-1.3102l2.3643 2.3643 4.9106-6.0018a.9264.9264 0 0 1 1.3037-.1304Z",
  fill: "#000001"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1432_6549)",
  key: "2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 2h12v12H2z"
}))], 'IconCheckedIcon', '1em', '1em', '', '0 0 16 16');
SvgIcon.displayName = 'IconChecked';
var _default = SvgIcon;
exports["default"] = _default;